<template>
  <sweet-modal
    ref="aboutModal"
    title="About..."
    class="modal-about"
    width="80%"
    @close="onClose"
  >
    <sweet-modal-tab id="tab1" title="MSP">
      <div>
        <h3 style="text-align: left">Marine Spatial Planning</h3>
        <br />
        <p>
          The IH-MSP Platform is an open access Web application that integrates
          technical and scientific knowledge from IHCantabria researchers in
          support of the 2030 agenda for sustainable development and associated
          SDGs. The Platform includes results from several research projects in
          relation with marine activities from global to local scale. This
          platform is being fed by different information obtained in several
          research projects, such as BTM, ATLAS, ATLAS-PRO, RENAQUA, ACUFLOT,
          among others
        </p>
        <a
          href="https://www.ihcantabria.com/en/"
          title="The Environmental Hydraulics Institute"
          target="blank"
        >
          <img class="logo-ih" src="@/assets/logos/IH_UC_original.png" />
        </a>
        <vs-divider>v.{{ version }}</vs-divider>
        <div class="video">
          <iframe
            src="https://player.vimeo.com/video/299010384"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </sweet-modal-tab>
    <sweet-modal-tab id="tab2" title="BTM">
      <div>
        <h3 style="text-align: left">Blue Time Machine</h3>
        <br />
        <p>
          In the framework of our Marine Spatial Planning Platform there is what
          we call 'The Blue Time Machine', a digital representation of the past,
          present and future conditions from our "Blue Planet". It provides
          "Past" (data generated using numerical models and open data with the
          last 60 years of relevant data), "Present" (real time data from
          Metocean Buoys and Coast Radars), and "Future" (with two scales,
          short-term data and climate changes projections). Additionally, there
          is a "Blue Growth" section with a set of processed data and calculated
          indexes for each economic sector, and specific tools that gives
          flexibility to the user on the representations of the results.
        </p>
        <a
          href="https://www.ihcantabria.com/en/"
          title="The Environmental Hydraulics Institute"
          target="blank"
        >
          <img class="logo-ih" src="@/assets/logos/IH_UC_original.png" />
        </a>
        <vs-divider>v.{{ version }}</vs-divider>
        <div class="video">
          <iframe
            src="https://player.vimeo.com/video/340207521"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          ></iframe>
          <p>
            <a href="https://vimeo.com/340207521">The Blue Time Machine</a> from
            <a href="https://vimeo.com/ihcantabria">IHCantabria</a> on
            <a href="https://vimeo.com">Vimeo</a>.
          </p>
        </div>
      </div>
    </sweet-modal-tab>
    <sweet-modal-tab id="tab3" title="ATLAS">
      <div class="project-grid">
        <div class="thumb-item">
          <img class="thumbs" src="@/assets/images/atlas_thumb.jpg" />
        </div>
        <div class="description-item">
          <h3 style="text-align: left">ATLAS</h3>
          <br />
          <p>
            Viability ATLAS for the development of offshore aquaculture in the
            Spanish coasts.
          </p>

          <div class="info-button">
            <vs-button
              href="https://www.programapleamar.es/proyectos/atlas-de-viabilidad-para-el-desarrollo-de-la-acuicultura-oceanica-en-espana-atlas/"
              class="accent"
              type="filled"
              target
              line-position="top"
              >+ Info</vs-button
            >
          </div>
        </div>
        <div class="logos-item">
          <vs-divider>with the support of</vs-divider>
          <a
            href="https://fundacion-biodiversidad.es/"
            title="MITECO - Fundación Biodiversidad"
            target="blank"
          >
            <img src="@/assets/logos/MITECO_FB_65h.png" />
          </a>
          <a
            href="https://www.programapleamar.es/"
            title="Programa Pleamar"
            target="blank"
          >
            <img src="@/assets/logos/PLEAMAR_65h.png" />
          </a>

          <a
            href="https://ec.europa.eu/fisheries/cfp/emff_es"
            title="FEMP"
            target="blank"
          >
            <img src="@/assets/logos/FEMP_65h.png" />
          </a>
        </div>
      </div>
    </sweet-modal-tab>
    <sweet-modal-tab id="tab5" title="ATLAS-PRO">
      <div>
        <h3 style="text-align: left">
          PROjection of climate change scenarios and downscaling to local scale
          of the ATLAS of viability of marine aquaculture on Spanish coasts
        </h3>
        <br />
        <p>
          The objective of ATLAS-PRO is to find solutions to the challenges of
          aquaculture in the 21st Century, using knowledge and innovation to
          acquire competitive advantages and adopt advanced management
          practices. ATLAS-PRO has analyzed the present and future of oceanic
          aquaculture in the Spanish waters based on innovative methodological
          approaches. The opportunities for macroalgae cultivation, the effect
          of climate change on farming opportunities of marine aquaculture and
          the viability of local aquaculture were analyzed. This knowledge will
          provide the productive sectors with information and tools about what
          species and areas are more suitable for aquaculture and what will
          happen with climate change.
        </p>
        <div class="info-button">
          <vs-button
            href="https://www.programapleamar.es/proyectos/atlas-pro-proyeccion-frente-escenarios-de-cambio-climatico-y-escalado-nivel-local-del"
            class="accent"
            type="filled"
            target
            line-position="top"
            >+ Info</vs-button
          >
        </div>
        <div class="video">
          <iframe
            src="https://player.vimeo.com/video/386911051"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
          >
          </iframe>
          <p>
            <a href="https://vimeo.com/386911051">Proyecto ATLAS PRO</a> from
            <a href="https://vimeo.com/ihcantabria">IHCantabria</a> on
            <a href="https://vimeo.com">Vimeo</a>.
          </p>
        </div>
      </div>
      <div class="logos-item">
        <vs-divider>v.{{ version }} with the support of</vs-divider>
        <a
          href="https://fundacion-biodiversidad.es/"
          title="MITECO - Fundación Biodiversidad"
          target="blank"
        >
          <img src="@/assets/logos/MITECO_FB_65h.png" />
        </a>
        <a
          href="https://www.programapleamar.es/"
          title="Programa Pleamar"
          target="blank"
        >
          <img src="@/assets/logos/PLEAMAR_65h.png" />
        </a>

        <a
          href="https://ec.europa.eu/fisheries/cfp/emff_es"
          title="FEMP"
          target="blank"
        >
          <img src="@/assets/logos/FEMP_65h.png" />
        </a>
      </div>
    </sweet-modal-tab>
    <sweet-modal-tab id="tab4" title="RENAQUA">
      <div class="renaqua-grid">
        <div class="thumb-item">
          <a
            href="http://renaqua.ihcantabria.com/"
            title="Renaqua Decision Support System"
            target="blank"
          >
            <img src="@/assets/logos/GlobalRenaqua_200h.png" />
          </a>
        </div>
        <div class="description-item">
          <h3 style="text-align: left">RENAQUA Decision Support System</h3>
          <br />
          <p>
            Co-location Opportunities for RENewable energies and AQUAculture
            facilities, decision support for operational Multi-Use Platform
            activities at coastal areas.
          </p>
          <div class="info-button">
            <vs-button
              class="accent"
              target
              type="filled"
              href="http://renaqua.ihcantabria.com/"
              >+ Info</vs-button
            >
          </div>
        </div>
      </div>
    </sweet-modal-tab>
    <sweet-modal-tab id="tab1" title="ACUFLOT">
      <div>
        <h3 style="text-align: left">ACUFLOT</h3>
        <br />
        <p>
          ACUFLOT aims to develop an integrated analysis system, which serves
          managers and the aquaculture sector as a tool for the future
          development of the Maritime Space Management Plans, POEM (Decree
          363/2017). These plans, which will be published in March 2021, pursue
          the sustainable development of the maritime sectors, including
          aquaculture and energy use. In this context, ACUFLOT will facilitate
          the evaluation of the opportunities of Spanish waters for the combined
          use of aquaculture and wind activity.
        </p>
        <div class="info-button">
          <vs-button
            class="accent"
            target
            type="filled"
            href="https://fundacion-biodiversidad.es/es/content/acuflot-interacciones-entre-la-acuicultura-offshore-y-la-energia-eolica-flotante-retos-y"
            >+ Info</vs-button
          >
        </div>
        <a
          href="https://www.ihcantabria.com/en/"
          title="The Environmental Hydraulics Institute"
          target="blank"
        >
          <img class="logo-ih" src="@/assets/logos/IH_UC_original.png" />
        </a>
        <vs-divider>v.{{ version }}</vs-divider>
      </div>
    </sweet-modal-tab>
  </sweet-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    autoOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tabColor: "#00a09e",
      version: process.env.VERSION,
    };
  },
  computed: {
    ...mapGetters({
      toggle: "isAboutModalVisible",
    }),
  },
  watch: {
    toggle() {
      if (this.toggle) {
        this.$refs.aboutModal.open();
      }
    },
  },
  mounted() {
    if (this.autoOpen) {
      this.$refs.aboutModal.open();
    }
  },
  methods: {
    ...mapActions({
      toggleAbout: "toggleAbout",
    }),
    onClose() {
      this.toggleAbout();
    },
  },
};
</script>
<style scoped>
.modal-about >>> .sweet-modal {
  max-width: 1100px !important;
}
.sweet-modal-overlay {
  background: rgba(0, 0, 0, 0.1);
}

.project-grid {
  display: grid;
  grid-gap: 1rem;
  max-height: 50vh;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 0.8fr 0.2fr;
}
.renaqua-grid {
  display: grid;
  grid-gap: 1rem;
  max-height: 50vh;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}

.thumb-item {
  grid-row: 1 / 2;
  grid-column: 1 / 2;
}
.description-item {
  grid-column: 2 / 2;
  grid-row: 1 / 2;
}
.logos-item {
  grid-row: 2 / 2;
  grid-column: span 2;
}

.logos-item img {
  margin: 10px;
}

.logo-ih {
  margin-top: 2rem;
  max-width: 225px;
}

.thumbs {
  max-height: 11rem;
}

.info-button {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.video {
  margin: 1rem;
}
.webinar {
  text-align: center;
}
</style>
